import qs from 'qs';
import { AUTH_URL } from '@ordermentum/ui-constants';

export const onGoogleButtonClick = () => {
  const queryParameter = {
    returnUrl: globalThis?.location.href,
  };

  globalThis?.location.assign(
    `${AUTH_URL}/v1/social/google?${qs.stringify({
      returnUri: `${globalThis?.location.origin}/social/upgrade?${qs.stringify(
        queryParameter
      )}`,
    })}`
  );
};
